import Vue from 'vue';
import * as Sentry from '@sentry/browser';
import * as Integrations from '@sentry/integrations';

Sentry.init({
  dsn: process.env.VUE_APP_SENTRY_DSN || '',
  environment: process.env.NODE_ENV,
  integrations: [new Integrations.Vue({ Vue: Vue as any, attachProps: true })],
});

export const sentry = Sentry;
